import setCreditCardChargeRequest from "../requests/setCreditCardChargeRequest";
import getSurchargedCartAction from "./getSurchargedCartAction";

const setCardAction = async (session, get, card) => {

    const surchargeRate = card?.charge_rate ?? 0;
    const currentSurchargeRate = get().getCreditCardChargeRate();

    const currentInput = get().input || {};
    const returnVal = {input: { ...currentInput, card }};

    if(surchargeRate !== currentSurchargeRate) {

        const orderID = get().orderID;
        const overPayment = get().getOverpayment();

        await setCreditCardChargeRequest(session, orderID, surchargeRate, overPayment);
        const refreshedOrder = await getSurchargedCartAction(session, false, get);
        for(const k of Object.keys(refreshedOrder)) {
            returnVal[k] = refreshedOrder[k];
        }

    }

    return returnVal;
}

export default setCardAction;